module.exports = __webpack_public_path__ + "img/review-1.7c194021.png";